module.exports = __webpack_public_path__ + "698298ae20586c8e37d04377495387fb.fbx";